/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { SlugFor } from 'app/shared/model/enumerations/slug-for.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { createEntity, getEntity, reset, updateEntity } from './url-slug.reducer';

export const UrlSlugUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const urlSlugEntity = useAppSelector(state => state.urlSlug.entity);
  const loading = useAppSelector(state => state.urlSlug.loading);
  const updating = useAppSelector(state => state.urlSlug.updating);
  const updateSuccess = useAppSelector(state => state.urlSlug.updateSuccess);
  const slugForValues = Object.keys(SlugFor);
  const entityTypeValues = Object.keys(EntityType);

  const handleClose = () => {
    navigate(`/url-slug${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createdDate !== undefined && typeof values.createdDate !== 'number') {
      values.createdDate = Number(values.createdDate);
    }
    if (values.timeToLive !== undefined && typeof values.timeToLive !== 'number') {
      values.timeToLive = Number(values.timeToLive);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...urlSlugEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          createdFor: 'PATIENT',
          entityType: 'LAB',
          ...urlSlugEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.urlSlug.home.createOrEditLabel" data-cy="UrlSlugCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.urlSlug.home.createOrEditLabel">Create or edit a UrlSlug</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="url-slug-id"
                  label={translate('tinyMedicRestApp.urlSlug.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.slug')}
                id="url-slug-slug"
                name="slug"
                data-cy="slug"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.originalUrl')}
                id="url-slug-originalUrl"
                name="originalUrl"
                data-cy="originalUrl"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.createdDate')}
                id="url-slug-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.timeToLive')}
                id="url-slug-timeToLive"
                name="timeToLive"
                data-cy="timeToLive"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.secret')}
                id="url-slug-secret"
                name="secret"
                data-cy="secret"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.createdFor')}
                id="url-slug-createdFor"
                name="createdFor"
                data-cy="createdFor"
                type="select"
              >
                {slugForValues.map(slugFor => (
                  <option value={slugFor} key={slugFor}>
                    {translate(`tinyMedicRestApp.SlugFor.${slugFor}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.entityType')}
                id="url-slug-entityType"
                name="entityType"
                data-cy="entityType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.entityId')}
                id="url-slug-entityId"
                name="entityId"
                data-cy="entityId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.active')}
                id="url-slug-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.cursor')}
                id="url-slug-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.lastUpdated')}
                id="url-slug-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.microSec')}
                id="url-slug-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.urlSlug.timestampEntry')}
                id="url-slug-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/url-slug" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UrlSlugUpdate;
